import {VueWizard} from "@/vue-wizard";
import {Component} from "vue-property-decorator";
import {RegisterAction} from "@/app/interfaces";
import {store} from "@/app/store";

@Component({
    name: "tabs-view-manager"
})
export default class TabsViewManager extends VueWizard {

    get currentActionIndex(): number {
        return store.state.currentActionIndex;
    }

    get registerActions(): RegisterAction[] {
        return store.state.registerActions;
    }

    selectCurrentAction(index: number) {
        store.commit('setCurrentActionIndex', index)
    }

}